export const unitCalc = (
  left: number | string,
  right: number | string,
  operator: '+' | '-' | '*' | '/' | '%'
) => {
  let leftUnit, rightUnit;
  if (typeof left === 'string') {
    leftUnit = left.replace(parseFloat(left).toString(), '');
    left = parseFloat(left);
  }
  if (typeof right === 'string') {
    rightUnit = right.replace(parseFloat(right).toString(), '');
    right = parseFloat(right);
  }

  const unit = leftUnit || rightUnit;

  switch (operator) {
    case '+':
      return unit ? left + right + unit : left + right;
    case '-':
      return unit ? left - right + unit : left - right;
    case '*':
      return unit ? left * right + unit : left * right;
    case '/':
      return unit ? left / right + unit : left / right;
    case '%':
      return unit ? (left % right) + unit : left % right;
    default:
      console.warn(
        'unitCalc only supports the following operators: +, -, *, /, %'
      );
      return left;
  }
};
